"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var styled_components_1 = __importStar(require("styled-components"));

var Header_1 = __importDefault(require("../../Header"));

var Icon_1 = __importDefault(require("../../Icon"));

var Wrapper = styled_components_1.default('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])));
var Text = styled_components_1.default('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  font-weight: normal;\n  ", ";\n"], ["\n  width: 100%;\n  font-weight: normal;\n  ", ";\n"])), function (_a) {
  var disabled = _a.disabled,
      theme = _a.theme;
  return disabled && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme.color.fadedText);
});
var ClickableText = styled_components_1.default(Text)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100%;\n  cursor: pointer;\n"], ["\n  width: 100%;\n  cursor: pointer;\n"])));
var Actions = styled_components_1.default('div')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var IconWrapper = styled_components_1.default('button')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  /* resets button styles */\n  padding: 0;\n  border: none;\n  font: inherit;\n  background-color: transparent;\n  text-align: inherit;\n\n  cursor: pointer;\n  transition: 0.2s linear all;\n\n  align-items: center;\n  ", ";\n"], ["\n  /* resets button styles */\n  padding: 0;\n  border: none;\n  font: inherit;\n  background-color: transparent;\n  text-align: inherit;\n\n  cursor: pointer;\n  transition: 0.2s linear all;\n\n  align-items: center;\n  ", ";\n"])), function (_a) {
  var disabled = _a.disabled,
      theme = _a.theme;
  return disabled && styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      cursor: not-allowed;\n      color: ", ";\n    "], ["\n      cursor: not-allowed;\n      color: ", ";\n    "])), theme.color.fadedText);
});
var StyleIcon = styled_components_1.default(Icon_1.default)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  ", ";\n"], ["\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  ", ";\n"])), function (_a) {
  var isRotate = _a.isRotate;
  return isRotate && styled_components_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      transform: rotate(180deg);\n    "], ["\n      transform: rotate(180deg);\n    "])));
});
var defaultProps = {
  size: 'm',
  noBottomGutter: false
};

var SegmentHeader =
/** @class */
function (_super) {
  __extends(SegmentHeader, _super);

  function SegmentHeader() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.collapse = function () {
      var _a = _this.props,
          toggleCollapse = _a.toggleCollapse,
          isCollapsed = _a.isCollapsed,
          disabled = _a.disabled;

      if (!disabled && toggleCollapse) {
        toggleCollapse(!isCollapsed);
      }
    };

    _this.renderActions = function () {
      var _a = _this.props,
          collapsible = _a.collapsible,
          onDispose = _a.onDispose,
          size = _a.size,
          disabled = _a.disabled,
          isCollapsed = _a.isCollapsed;
      var iconSize = typeof size === 'string' ? _this.sizeToPx(size) : size;
      var actions = [];

      if (collapsible) {
        actions.push(React.createElement(IconWrapper, {
          key: "collapse",
          onClick: _this.collapse,
          disabled: disabled,
          "data-testid": "Segment-IconArrowDown"
        }, disabled ? React.createElement(StyleIcon, {
          name: "arrow-down",
          size: iconSize,
          isRotate: isCollapsed,
          color: "#e0e0eb"
        }) : React.createElement(StyleIcon, {
          name: "arrow-down",
          size: iconSize,
          isRotate: isCollapsed
        })));
      }

      if (onDispose) {
        actions.push(React.createElement(IconWrapper, {
          key: "close",
          onClick: onDispose,
          disabled: disabled,
          "data-testid": "Segment-IconClose"
        }, disabled ? React.createElement(Icon_1.default, {
          name: "close",
          size: iconSize,
          color: "#e0e0eb"
        }) : React.createElement(Icon_1.default, {
          name: "close",
          size: iconSize
        })));
      }

      return actions;
    };

    return _this;
  }

  SegmentHeader.prototype.sizeToPx = function (size) {
    var sizeMapping = {
      xs: 16,
      s: 18,
      m: 20,
      l: 22,
      xl: 24
    };
    return size in sizeMapping ? sizeMapping[size] : 16;
  };

  SegmentHeader.prototype.render = function () {
    var _a = this.props,
        size = _a.size,
        subtitle = _a.subtitle,
        withSeparator = _a.withSeparator,
        noBottomGutter = _a.noBottomGutter,
        children = _a.children,
        collapsible = _a.collapsible,
        disabled = _a.disabled;
    return React.createElement(Header_1.default, {
      noBottomGutter: noBottomGutter,
      subtitle: subtitle,
      size: size,
      withSeparator: withSeparator
    }, React.createElement(Wrapper, null, collapsible ? React.createElement(ClickableText, {
      disabled: disabled,
      onClick: this.collapse
    }, children) : React.createElement(Text, {
      disabled: disabled
    }, children), React.createElement(Actions, null, this.renderActions())));
  };

  SegmentHeader.defaultProps = defaultProps;
  return SegmentHeader;
}(React.PureComponent);

exports.default = styled_components_1.withTheme(SegmentHeader);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;